import { Grid, Paper } from "@mui/material";
import React, { useState } from "react";
import { Button, Input } from "../../../../controls";

import { Form } from "../../../../layout";
import { API, action, controller } from "../../../../api/api";
import { ToFormData } from "../../../../hooks/Method";

const CancelOrderForm = (props) => {
  const { setAlert, setShowForm, order, setOrder } = props;
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (order && reason) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && res.status === 200) {
          setOrder && setOrder((j) => ({ ...j, ...res.result }));
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
          });
          setShowForm(false);
        } else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      API(controller.Stock + action.CancelOrder).post(
        ToFormData({
          id: order.id,
          value: reason,
        }),
        onComplete
      );
    } else if (!reason) setErrors("Cancel reason is required");
    else
      setErrors("Order data not found. Please refresh the page and try again.");
  };

  const handleClose = () => {
    setShowForm(false);
  };

  const handleChgReason = (e) => {
    setReason(e.target.value);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper className="max-w-[500px]">
          <Grid container spacing={2} className="p-[15px]">
            <Grid item xs={12} className="text-center !p-[20px] w-[100%]">
              <span className="font-medium text-[24px] uppercase text-gray-500">
                Cancel Order
              </span>
              <div className="relative flex justify-center">
                <div className="border-bottom w-[60px]" />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Cancel Reason"
                value={reason}
                error={errors}
                multiline
                rows={4}
                onChange={handleChgReason}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex gap-2 mt-[15px]">
                <Button
                  fullWidth
                  size="large"
                  variant="text"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button fullWidth size="large" loading={loading} type="submit">
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default CancelOrderForm;
